// Part of settingsPages, split by screen to keep files short; ../settingsPages.ts merges the parts.
export const en = {
  data: {
    tree: {
      classWord: 'class',
      locationWord: 'location',
      locationLabel: 'Location',
      classesTitle: 'Classes',
      locationsTitle: 'Locations',
      customTitle: '{{label}}s',
      classesDescription:
        'Classes group transactions by department, product line or any other segment, for profit and loss by class.',
      locationsDescription:
        'Each transaction belongs to one {{word}}, for profit and loss by {{word}}.',
      newClass: 'New class',
      newItem: 'New {{word}}',
      editClass: 'Edit class',
      editItem: 'Edit {{word}}',
      classesOff:
        'Class tracking is off, so forms do not show it. Switch it on in Company settings › Advanced › Categories.',
      locationsOff:
        '{{label}} tracking is off, so forms do not show it. Switch it on in Company settings › Advanced › Categories.',
      show: 'Show',
      active: 'Active',
      all: 'All',
      couldNotLoad: 'Could not load {{what}}',
      noneYet: 'No {{what}} yet',
      classesExample: 'For example Retail, Wholesale, Projects.',
      locationsExample: 'For example Dubai, Abu Dhabi, Mumbai.',
      name: 'Name',
      status: 'Status',
      action: 'Action',
      moreActions: 'More actions for {{name}}',
      makeInactive: 'Make inactive',
      makeActive: 'Make active',
      delete: 'Delete',
      deleted: '"{{name}}" deleted.',
      nowInactive: '"{{name}}" is inactive.',
      nowActive: '"{{name}}" is active.',
      saved: '"{{name}}" saved.',
      uniqueNames: 'Names are unique under the same parent.',
      nameRequired: 'Name *',
      isSubClass: 'Is sub-class',
      isSubItem: 'Is sub-{{word}}',
      parentClass: 'Parent class',
      parentItem: 'Parent {{word}}',
      chooseParent: 'Choose a parent',
    },
    tracking: {
      location: 'Location',
      class: 'Class',
      project: 'Project',
      tags: 'Tags',
      inactiveSuffix: ' (inactive)',
      removeTag: 'Remove tag {{name}}',
      addTag: 'Add a tag',
      addAnotherTag: 'Add another tag',
      noTags: 'No tags',
      projectStatus: {
        in_progress: 'In progress',
        completed: 'Completed',
        cancelled: 'Cancelled',
      },
    },
    project: {
      newTitle: 'New project',
      editTitle: 'Edit project',
      description: 'Invoices, bills, expenses and journals can name the project.',
      nameRequired: 'Project name *',
      customerRequired: 'Customer *',
      chooseCustomer: 'Choose a customer',
      startDate: 'Start date',
      endDate: 'End date',
      notes: 'Notes',
      endBeforeStart: 'The end date is on or after the start date.',
      saved: 'Project "{{name}}" saved.',
    },
    tags: {
      title: 'Tags',
      description:
        'Label transactions for your own tracking, such as a campaign or an event. Tags can be changed on posted transactions; they never change the books.',
      newTag: 'Tag',
      newGroup: 'Tag group',
      couldNotLoad: 'Could not load tags',
      noneYet: 'No tags yet',
      example: 'For example a group Campaign with Ramadan and Diwali.',
      transactions: 'Transactions',
      ungrouped: 'Ungrouped tags',
      addTag: 'Add tag',
      rename: 'Rename',
      tagDeleted: 'Tag "{{name}}" deleted.',
      groupDeleted: 'Tag group "{{name}}" deleted.',
      newTagTitle: 'New tag',
      editTagTitle: 'Edit tag',
      newGroupTitle: 'New tag group',
      editGroupTitle: 'Edit tag group',
      groupNamesUnique: 'Group names are unique.',
      tagNamesUnique: 'Tag names are unique within their group.',
      group: 'Group',
      noGroup: 'No group',
      tagSaved: 'Tag "{{name}}" saved.',
      groupSaved: 'Tag group "{{name}}" saved.',
    },
    importTypes: {
      accounts: {
        title: 'Chart of accounts',
        description: 'Account numbers, names, types, detail types and sub-accounts.',
      },
      customers: {
        title: 'Customers',
        description: 'Names, contact details, addresses, TRNs, terms and default VAT.',
      },
      vendors: {
        title: 'Vendors',
        description: 'Names, contact details, TRNs, terms, default category and bank details.',
      },
      items: {
        title: 'Products and services',
        description: 'Names, SKUs, sales prices and costs, accounts and tax codes.',
      },
    },
    importHub: {
      title: 'Import data',
      description:
        'Bring lists in from a CSV file, such as a QuickBooks export or one of our sample files.',
      moveTitle: 'Move from QuickBooks',
      moveDescription:
        'A checklist that walks through every import in order, ties the open items to the opening trial balance and locks the books at the conversion date.',
      more: {
        openingBalances: {
          title: 'Opening balances',
          description: 'The trial balance on your start date, mapped to your accounts.',
        },
        openInvoices: {
          title: 'Open invoices',
          description: 'Invoices and credits customers still owe at your start date.',
        },
        unpaidBills: {
          title: 'Unpaid bills',
          description: 'Bills and debit notes still open with vendors at your start date.',
        },
        bankStatement: {
          title: 'Bank statement',
          description: 'CSV or OFX statement lines.',
        },
      },
    },
    importWizard: {
      pageTitle: 'Import {{what}}',
      pageDescription:
        'Upload a CSV file, match its columns, review the rows, then import the ones without errors.',
      allImports: 'All imports',
      staffOnly: 'Only accounting staff can import data',
      staffOnlyHint: 'Ask your accountant to import lists for you.',
      couldNotLoad: 'Could not load the import',
      emptyFile: 'The file is empty or has no header row.',
      notUtf8:
        'The file is not UTF-8, so Arabic text cannot be read. In Excel, save it as "CSV UTF-8 (Comma delimited)" and try again.',
      chooseCsv: 'Choose a .csv file. In Excel, use File › Save as › CSV UTF-8.',
      noDataRows: 'The file has a header row but no data rows.',
      tooManyRows: 'The file has {{rows}} rows; import at most {{max}} at a time.',
      errorsColumn: 'Errors',
      steps: 'Import steps',
      step: {
        upload: 'Upload',
        map: 'Map columns',
        review: 'Review',
        done: 'Done',
      },
      dropHere: 'Drag and drop a CSV file here, or browse',
      uploadHint:
        'Up to {{max}} rows. The first row must hold the column names. Excel files: save as CSV UTF-8 first.',
      browse: 'Browse',
      downloadSample: 'Download sample file',
      csvFile: 'CSV file',
      fieldsYouCanImport: 'Fields you can import',
      mapMissing: 'Map a column to {{fields}}.',
      mappedTwice: 'Each column can feed one field: {{columns}} is mapped twice.',
      fileSummary_one: '{{rows}} rows · {{columns}} columns.',
      fileSummary_other: '{{rows}} rows · {{columns}} columns.',
      matched:
        'We matched what we recognised; check the rest. The mapping is remembered for this client.',
      matchedWithSaved:
        'We matched what we recognised and your saved mapping; check the rest. The mapping is remembered for this client.',
      fieldColumn: 'Outss Accounting field',
      fileColumn: 'Column in your file',
      firstRow: 'First row',
      columnFor: 'Column for {{field}}',
      notMapped: 'Not mapped',
      notImported: 'Not imported: {{columns}}.',
      back: 'Back',
      next: 'Next',
      checkingRows: 'Checking rows…',
      importedSummary_one: 'Imported {{ok}} of {{total}} rows into {{what}}.',
      importedSummary_other: 'Imported {{ok}} of {{total}} rows into {{what}}.',
      skippedErrors_one:
        '{{n}} rows with errors were skipped; download the error report, fix them and import that file.',
      skippedErrors_other:
        '{{n}} rows with errors were skipped; download the error report, fix them and import that file.',
      everyRowImported: 'Every row was imported.',
      readySummary_one: '{{ok}} of {{total}} rows are ready to import.',
      readySummary_other: '{{ok}} of {{total}} rows are ready to import.',
      willSkip_one:
        '{{n}} rows have errors and will be skipped unless you fix the file and upload it again.',
      willSkip_other:
        '{{n}} rows have errors and will be skipped unless you fix the file and upload it again.',
      noErrors: 'No errors found.',
      onlyErrors: 'Show only rows with errors',
      downloadErrors: 'Download error report',
      line: 'Line',
      name: 'Name',
      status: 'Status',
      blank: '(blank)',
      imported: 'Imported',
      ready: 'Ready',
      error: 'Error',
      importAnother: 'Import another file',
      viewList: 'View {{what}}',
      importing: 'Importing…',
      importRows_one: 'Import {{n}} row',
      importRows_other: 'Import {{n}} rows',
    },
    export: {
      title: 'Export data',
      description:
        'Download reports, lists and the journal as Excel or CSV files. Lists use the same columns as Import data, so they import into another client.',
      format: {
        xlsx: 'Excel (.xlsx)',
        csv: 'CSV',
      },
      formatLabel: 'Format',
      reportsTitle: 'Reports',
      reportsDescription: 'Each report downloads as its own file for the period you choose.',
      clearAll: 'Clear all',
      selectAll: 'Select all',
      reportPeriod: 'Report period',
      exporting: 'Exporting…',
      exportReports: 'Export reports',
      exportReportsCount_one: 'Export {{count}} reports',
      exportReportsCount_other: 'Export {{count}} reports',
      listsTitle: 'Lists',
      listsDescription:
        'Chart of accounts, customers, vendors and products and services, in the Import data columns.',
      exportLists: 'Export lists',
      exportListsCount_one: 'Export {{count}} lists',
      exportListsCount_other: 'Export {{count}} lists',
      journalTitle: 'Journal',
      journalDescription:
        'Every journal line of this client, posted and reversed, with the account, name, VAT code, currency and home-currency amounts. Leave the dates empty for the whole journal.',
      from: 'From',
      to: 'To',
      endBeforeStart: 'The end date is before the start date',
      exportJournal: 'Export journal',
      filesDownloaded_one: '1 file downloaded',
      filesDownloaded_other: '{{count}} files downloaded',
      partlyFailed_one: '{{count}} downloaded; could not export {{names}}',
      partlyFailed_other: '{{count}} downloaded; could not export {{names}}',
      allFailed: 'could not export {{names}}',
      report: {
        'profit-and-loss': 'Profit and loss',
        'balance-sheet': 'Balance sheet',
        'cash-flow': 'Statement of cash flows',
        'trial-balance': 'Trial balance',
        'general-ledger': 'General ledger',
        journal: 'Journal',
        'transaction-list-by-date': 'Transaction list by date',
        'ar-aging-summary': 'A/R ageing summary',
        'customer-balance-summary': 'Customer balance summary',
        'ap-aging-summary': 'A/P ageing summary',
        'vendor-balance-summary': 'Vendor balance summary',
      },
    },
  },
};

export const ar = {
  data: {
    tree: {
      classWord: 'فئة',
      locationWord: 'موقع',
      locationLabel: 'الموقع',
      classesTitle: 'الفئات',
      locationsTitle: 'المواقع',
      customTitle: '{{label}}',
      classesDescription:
        'تجمع الفئات المعاملات حسب القسم أو خط المنتجات أو أي شريحة أخرى، لعرض الأرباح والخسائر حسب الفئة.',
      locationsDescription:
        'تنتمي كل معاملة إلى {{word}} واحد، لعرض الأرباح والخسائر حسب {{word}}.',
      newClass: 'فئة جديدة',
      newItem: 'إضافة {{word}}',
      editClass: 'تعديل الفئة',
      editItem: 'تعديل {{word}}',
      classesOff:
        'تتبّع الفئات متوقف، لذا لا يظهر في النماذج. شغّله من إعدادات الشركة › متقدم › التصنيفات.',
      locationsOff:
        'تتبّع {{label}} متوقف، لذا لا يظهر في النماذج. شغّله من إعدادات الشركة › متقدم › التصنيفات.',
      show: 'عرض',
      active: 'نشط',
      all: 'الكل',
      couldNotLoad: 'تعذّر تحميل {{what}}',
      noneYet: 'لا توجد {{what}} بعد',
      classesExample: 'مثلاً: التجزئة، الجملة، المشاريع.',
      locationsExample: 'مثلاً: دبي، أبوظبي، مومباي.',
      name: 'الاسم',
      status: 'الحالة',
      action: 'الإجراء',
      moreActions: 'إجراءات أخرى لـ {{name}}',
      makeInactive: 'جعله غير نشط',
      makeActive: 'جعله نشطاً',
      delete: 'حذف',
      deleted: 'تم حذف "{{name}}".',
      nowInactive: 'أصبح "{{name}}" غير نشط.',
      nowActive: 'أصبح "{{name}}" نشطاً.',
      saved: 'تم حفظ "{{name}}".',
      uniqueNames: 'لا تتكرر الأسماء تحت الأصل نفسه.',
      nameRequired: 'الاسم *',
      isSubClass: 'فئة فرعية',
      isSubItem: '{{word}} فرعي',
      parentClass: 'الفئة الأصل',
      parentItem: '{{word}} الأصل',
      chooseParent: 'اختر الأصل',
    },
    tracking: {
      location: 'الموقع',
      class: 'الفئة',
      project: 'المشروع',
      tags: 'الوسوم',
      inactiveSuffix: ' (غير نشط)',
      removeTag: 'إزالة الوسم {{name}}',
      addTag: 'إضافة وسم',
      addAnotherTag: 'إضافة وسم آخر',
      noTags: 'لا توجد وسوم',
      projectStatus: {
        in_progress: 'قيد التنفيذ',
        completed: 'مكتمل',
        cancelled: 'ملغى',
      },
    },
    project: {
      newTitle: 'مشروع جديد',
      editTitle: 'تعديل المشروع',
      description: 'يمكن ذكر المشروع في الفواتير وفواتير الموردين والمصروفات والقيود.',
      nameRequired: 'اسم المشروع *',
      customerRequired: 'العميل *',
      chooseCustomer: 'اختر عميلاً',
      startDate: 'تاريخ البدء',
      endDate: 'تاريخ الانتهاء',
      notes: 'ملاحظات',
      endBeforeStart: 'يجب أن يكون تاريخ الانتهاء في تاريخ البدء أو بعده.',
      saved: 'تم حفظ المشروع "{{name}}".',
    },
    tags: {
      title: 'الوسوم',
      description:
        'صنّف المعاملات لمتابعتك الخاصة، مثل حملة أو مناسبة. يمكن تغيير الوسوم على المعاملات المرحّلة، ولا تغيّر الدفاتر أبداً.',
      newTag: 'وسم',
      newGroup: 'مجموعة وسوم',
      couldNotLoad: 'تعذّر تحميل الوسوم',
      noneYet: 'لا توجد وسوم بعد',
      example: 'مثلاً مجموعة "حملة" تضم رمضان وديوالي.',
      transactions: 'المعاملات',
      ungrouped: 'وسوم بلا مجموعة',
      addTag: 'إضافة وسم',
      rename: 'إعادة تسمية',
      tagDeleted: 'تم حذف الوسم "{{name}}".',
      groupDeleted: 'تم حذف مجموعة الوسوم "{{name}}".',
      newTagTitle: 'وسم جديد',
      editTagTitle: 'تعديل الوسم',
      newGroupTitle: 'مجموعة وسوم جديدة',
      editGroupTitle: 'تعديل مجموعة الوسوم',
      groupNamesUnique: 'لا تتكرر أسماء المجموعات.',
      tagNamesUnique: 'لا تتكرر أسماء الوسوم داخل المجموعة نفسها.',
      group: 'المجموعة',
      noGroup: 'بلا مجموعة',
      tagSaved: 'تم حفظ الوسم "{{name}}".',
      groupSaved: 'تم حفظ مجموعة الوسوم "{{name}}".',
    },
    importTypes: {
      accounts: {
        title: 'دليل الحسابات',
        description: 'أرقام الحسابات وأسماؤها وأنواعها وأنواعها التفصيلية والحسابات الفرعية.',
      },
      customers: {
        title: 'العملاء',
        description:
          'الأسماء وبيانات الاتصال والعناوين وأرقام التسجيل الضريبي وشروط الدفع وضريبة القيمة المضافة الافتراضية.',
      },
      vendors: {
        title: 'الموردون',
        description:
          'الأسماء وبيانات الاتصال وأرقام التسجيل الضريبي وشروط الدفع والفئة الافتراضية والبيانات البنكية.',
      },
      items: {
        title: 'المنتجات والخدمات',
        description: 'الأسماء ورموز SKU وأسعار البيع والتكاليف والحسابات ورموز الضريبة.',
      },
    },
    importHub: {
      title: 'استيراد البيانات',
      description:
        'أدخِل القوائم من ملف CSV، مثل ملف مُصدَّر من QuickBooks أو أحد ملفاتنا النموذجية.',
      moveTitle: 'الانتقال من QuickBooks',
      moveDescription:
        'قائمة مراجعة ترشدك إلى كل عملية استيراد بالترتيب، وتطابق البنود المفتوحة مع ميزان المراجعة الافتتاحي، وتقفل الدفاتر في تاريخ التحويل.',
      more: {
        openingBalances: {
          title: 'الأرصدة الافتتاحية',
          description: 'ميزان المراجعة في تاريخ البدء، مربوطاً بحساباتك.',
        },
        openInvoices: {
          title: 'الفواتير المفتوحة',
          description: 'الفواتير والأرصدة الدائنة التي لا تزال مستحقة على العملاء في تاريخ البدء.',
        },
        unpaidBills: {
          title: 'فواتير الموردين غير المدفوعة',
          description: 'فواتير الموردين والإشعارات المدينة التي لا تزال مفتوحة في تاريخ البدء.',
        },
        bankStatement: {
          title: 'كشف الحساب البنكي',
          description: 'بنود كشف الحساب بصيغة CSV أو OFX.',
        },
      },
    },
    importWizard: {
      pageTitle: 'استيراد {{what}}',
      pageDescription:
        'ارفع ملف CSV، وطابق أعمدته، وراجع الصفوف، ثم استورد الصفوف الخالية من الأخطاء.',
      allImports: 'كل عمليات الاستيراد',
      staffOnly: 'استيراد البيانات متاح لفريق المحاسبة فقط',
      staffOnlyHint: 'اطلب من محاسبك استيراد القوائم نيابةً عنك.',
      couldNotLoad: 'تعذّر تحميل عملية الاستيراد',
      emptyFile: 'الملف فارغ أو لا يحتوي على صف عناوين.',
      notUtf8:
        'الملف ليس بترميز UTF-8، لذا لا يمكن قراءة النص العربي. في Excel، احفظه بصيغة "CSV UTF-8 (Comma delimited)" وحاول مرة أخرى.',
      chooseCsv: 'اختر ملفاً بامتداد ‎.csv. في Excel، استخدم File › Save as › CSV UTF-8.',
      noDataRows: 'يحتوي الملف على صف العناوين فقط دون صفوف بيانات.',
      tooManyRows: 'يحتوي الملف على {{rows}} صفاً؛ استورد {{max}} صف كحد أقصى في كل مرة.',
      errorsColumn: 'الأخطاء',
      steps: 'خطوات الاستيراد',
      step: {
        upload: 'الرفع',
        map: 'مطابقة الأعمدة',
        review: 'المراجعة',
        done: 'تم',
      },
      dropHere: 'اسحب ملف CSV وأفلته هنا، أو تصفّح',
      uploadHint:
        'حتى {{max}} صف. يجب أن يحتوي الصف الأول على أسماء الأعمدة. ملفات Excel: احفظها بصيغة CSV UTF-8 أولاً.',
      browse: 'تصفّح',
      downloadSample: 'تنزيل ملف نموذجي',
      csvFile: 'ملف CSV',
      fieldsYouCanImport: 'الحقول التي يمكنك استيرادها',
      mapMissing: 'اربط عموداً بالحقول: {{fields}}.',
      mappedTwice: 'كل عمود يغذّي حقلاً واحداً: {{columns}} مربوط مرتين.',
      fileSummary_zero: '{{rows}} صف · {{columns}} عمود.',
      fileSummary_one: '{{rows}} صف · {{columns}} عمود.',
      fileSummary_two: '{{rows}} صف · {{columns}} عمود.',
      fileSummary_few: '{{rows}} صفوف · {{columns}} عمود.',
      fileSummary_many: '{{rows}} صفاً · {{columns}} عمود.',
      fileSummary_other: '{{rows}} صف · {{columns}} عمود.',
      matched: 'طابقنا ما تعرّفنا عليه؛ راجع الباقي. تُحفظ المطابقة لهذا العميل.',
      matchedWithSaved:
        'طابقنا ما تعرّفنا عليه ومطابقتك المحفوظة؛ راجع الباقي. تُحفظ المطابقة لهذا العميل.',
      fieldColumn: 'حقل Outss Accounting',
      fileColumn: 'العمود في ملفك',
      firstRow: 'الصف الأول',
      columnFor: 'العمود الخاص بـ {{field}}',
      notMapped: 'غير مربوط',
      notImported: 'لن يُستورد: {{columns}}.',
      back: 'رجوع',
      next: 'التالي',
      checkingRows: 'جارٍ فحص الصفوف…',
      importedSummary_zero: 'تم استيراد {{ok}} من {{total}} صف إلى {{what}}.',
      importedSummary_one: 'تم استيراد {{ok}} من {{total}} صف إلى {{what}}.',
      importedSummary_two: 'تم استيراد {{ok}} من {{total}} صف إلى {{what}}.',
      importedSummary_few: 'تم استيراد {{ok}} من {{total}} صفوف إلى {{what}}.',
      importedSummary_many: 'تم استيراد {{ok}} من {{total}} صفاً إلى {{what}}.',
      importedSummary_other: 'تم استيراد {{ok}} من {{total}} صف إلى {{what}}.',
      skippedErrors_zero:
        'تم تخطي {{n}} صف فيها أخطاء؛ نزّل تقرير الأخطاء، وصحّحها، ثم استورد ذلك الملف.',
      skippedErrors_one:
        'تم تخطي {{n}} صف فيه أخطاء؛ نزّل تقرير الأخطاء، وصحّحه، ثم استورد ذلك الملف.',
      skippedErrors_two:
        'تم تخطي {{n}} صف فيهما أخطاء؛ نزّل تقرير الأخطاء، وصحّحهما، ثم استورد ذلك الملف.',
      skippedErrors_few:
        'تم تخطي {{n}} صفوف فيها أخطاء؛ نزّل تقرير الأخطاء، وصحّحها، ثم استورد ذلك الملف.',
      skippedErrors_many:
        'تم تخطي {{n}} صفاً فيها أخطاء؛ نزّل تقرير الأخطاء، وصحّحها، ثم استورد ذلك الملف.',
      skippedErrors_other:
        'تم تخطي {{n}} صف فيها أخطاء؛ نزّل تقرير الأخطاء، وصحّحها، ثم استورد ذلك الملف.',
      everyRowImported: 'تم استيراد كل الصفوف.',
      readySummary_zero: '{{ok}} من {{total}} صف جاهزة للاستيراد.',
      readySummary_one: '{{ok}} من {{total}} صف جاهز للاستيراد.',
      readySummary_two: '{{ok}} من {{total}} صف جاهزة للاستيراد.',
      readySummary_few: '{{ok}} من {{total}} صفوف جاهزة للاستيراد.',
      readySummary_many: '{{ok}} من {{total}} صفاً جاهزة للاستيراد.',
      readySummary_other: '{{ok}} من {{total}} صف جاهزة للاستيراد.',
      willSkip_zero: '{{n}} صف فيها أخطاء وسيتم تخطيها ما لم تصحّح الملف وترفعه مرة أخرى.',
      willSkip_one: '{{n}} صف فيه أخطاء وسيتم تخطيه ما لم تصحّح الملف وترفعه مرة أخرى.',
      willSkip_two: '{{n}} صف فيهما أخطاء وسيتم تخطيهما ما لم تصحّح الملف وترفعه مرة أخرى.',
      willSkip_few: '{{n}} صفوف فيها أخطاء وسيتم تخطيها ما لم تصحّح الملف وترفعه مرة أخرى.',
      willSkip_many: '{{n}} صفاً فيها أخطاء وسيتم تخطيها ما لم تصحّح الملف وترفعه مرة أخرى.',
      willSkip_other: '{{n}} صف فيها أخطاء وسيتم تخطيها ما لم تصحّح الملف وترفعه مرة أخرى.',
      noErrors: 'لم يتم العثور على أخطاء.',
      onlyErrors: 'عرض الصفوف التي فيها أخطاء فقط',
      downloadErrors: 'تنزيل تقرير الأخطاء',
      line: 'السطر',
      name: 'الاسم',
      status: 'الحالة',
      blank: '(فارغ)',
      imported: 'تم الاستيراد',
      ready: 'جاهز',
      error: 'خطأ',
      importAnother: 'استيراد ملف آخر',
      viewList: 'عرض {{what}}',
      importing: 'جارٍ الاستيراد…',
      importRows_zero: 'استيراد {{n}} صف',
      importRows_one: 'استيراد {{n}} صف',
      importRows_two: 'استيراد {{n}} صف',
      importRows_few: 'استيراد {{n}} صفوف',
      importRows_many: 'استيراد {{n}} صفاً',
      importRows_other: 'استيراد {{n}} صف',
    },
    export: {
      title: 'تصدير البيانات',
      description:
        'نزّل التقارير والقوائم والقيود كملفات Excel أو CSV. تستخدم القوائم أعمدة استيراد البيانات نفسها، لذا يمكن استيرادها إلى عميل آخر.',
      format: {
        xlsx: 'Excel ‏(.xlsx)',
        csv: 'CSV',
      },
      formatLabel: 'الصيغة',
      reportsTitle: 'التقارير',
      reportsDescription: 'يُنزَّل كل تقرير في ملف مستقل للفترة التي تختارها.',
      clearAll: 'إلغاء تحديد الكل',
      selectAll: 'تحديد الكل',
      reportPeriod: 'فترة التقرير',
      exporting: 'جارٍ التصدير…',
      exportReports: 'تصدير التقارير',
      exportReportsCount_zero: 'تصدير {{count}} تقرير',
      exportReportsCount_one: 'تصدير تقرير واحد',
      exportReportsCount_two: 'تصدير تقريرين',
      exportReportsCount_few: 'تصدير {{count}} تقارير',
      exportReportsCount_many: 'تصدير {{count}} تقريراً',
      exportReportsCount_other: 'تصدير {{count}} تقرير',
      listsTitle: 'القوائم',
      listsDescription:
        'دليل الحسابات والعملاء والموردون والمنتجات والخدمات، بأعمدة استيراد البيانات.',
      exportLists: 'تصدير القوائم',
      exportListsCount_zero: 'تصدير {{count}} قائمة',
      exportListsCount_one: 'تصدير قائمة واحدة',
      exportListsCount_two: 'تصدير قائمتين',
      exportListsCount_few: 'تصدير {{count}} قوائم',
      exportListsCount_many: 'تصدير {{count}} قائمةً',
      exportListsCount_other: 'تصدير {{count}} قائمة',
      journalTitle: 'دفتر اليومية',
      journalDescription:
        'كل بنود قيود هذا العميل، المرحّلة والمعكوسة، مع الحساب والاسم ورمز ضريبة القيمة المضافة والعملة والمبالغ بالعملة الأساسية. اترك التاريخين فارغين لتصدير الدفتر كاملاً.',
      from: 'من',
      to: 'إلى',
      endBeforeStart: 'تاريخ الانتهاء قبل تاريخ البدء',
      exportJournal: 'تصدير دفتر اليومية',
      filesDownloaded_zero: 'لم يُنزَّل أي ملف',
      filesDownloaded_one: 'تم تنزيل ملف واحد',
      filesDownloaded_two: 'تم تنزيل ملفين',
      filesDownloaded_few: 'تم تنزيل {{count}} ملفات',
      filesDownloaded_many: 'تم تنزيل {{count}} ملفاً',
      filesDownloaded_other: 'تم تنزيل {{count}} ملف',
      partlyFailed_zero: 'تم تنزيل {{count}}؛ تعذّر تصدير {{names}}',
      partlyFailed_one: 'تم تنزيل ملف واحد؛ تعذّر تصدير {{names}}',
      partlyFailed_two: 'تم تنزيل ملفين؛ تعذّر تصدير {{names}}',
      partlyFailed_few: 'تم تنزيل {{count}} ملفات؛ تعذّر تصدير {{names}}',
      partlyFailed_many: 'تم تنزيل {{count}} ملفاً؛ تعذّر تصدير {{names}}',
      partlyFailed_other: 'تم تنزيل {{count}} ملف؛ تعذّر تصدير {{names}}',
      allFailed: 'تعذّر تصدير {{names}}',
      report: {
        'profit-and-loss': 'الأرباح والخسائر',
        'balance-sheet': 'الميزانية العمومية',
        'cash-flow': 'قائمة التدفقات النقدية',
        'trial-balance': 'ميزان المراجعة',
        'general-ledger': 'دفتر الأستاذ العام',
        journal: 'دفتر اليومية',
        'transaction-list-by-date': 'قائمة المعاملات حسب التاريخ',
        'ar-aging-summary': 'ملخص أعمار الذمم المدينة',
        'customer-balance-summary': 'ملخص أرصدة العملاء',
        'ap-aging-summary': 'ملخص أعمار الذمم الدائنة',
        'vendor-balance-summary': 'ملخص أرصدة الموردين',
      },
    },
  },
};
